module.exports = __webpack_public_path__ + "static/media/welcomeSection3Image1.3e679678.gif";